import ButtonSlider from "./buttonSlider";

export default ButtonSlider;